import React, { useState } from 'react';
import { BsGithub } from 'react-icons/bs';
import Modal from './Modal'; // Make sure to import the Modal component

const ProjectsCard = ({ title, des, src, githubLink }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  // Shorten the description for the card view
  const shortDescription = des.length > 100 ? `${des.substring(0, 100)}...` : des;

  return (
    <div className="relative">
      <div
        className="flex flex-col h-full border border-gray-600 rounded-lg overflow-hidden shadow-lg cursor-pointer hover:shadow-xl transition-shadow duration-300 bg-bodyColor"
        onClick={toggleModal}
      >
        <img className="w-full h-48 object-cover" src={src} alt={title} />
        <div className="flex flex-col flex-grow p-4">
          <div className="flex justify-between items-center mb-2 min-h-[60px]">
            <h3 className="text-xl font-semibold text-gray-100">{title}</h3>
            <a
              href={githubLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-lg w-10 h-10 rounded-full bg-gray-800 inline-flex justify-center items-center text-white hover:text-gray-400 duration-300 cursor-pointer ml-4"
              onClick={(e) => e.stopPropagation()} // Prevents the card from toggling when the GitHub link is clicked
            >
              <BsGithub className="w-6 h-6" />
            </a>
          </div>
          <p className="text-gray-300">{shortDescription}</p>
        </div>
      </div>

      <Modal
        show={isModalOpen}
        onClose={toggleModal}
        title={title}
        des={des}
        src={src}
        githubLink={githubLink}
      />
    </div>
  );
};

export default ProjectsCard;
